// Import Packages
import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useRecoilValue } from 'recoil';
import { Link } from 'react-router-dom';

// Import Material UI
import { Grid, Switch } from '@material-ui/core';
import PlayCircleFilledWhiteIcon from "@material-ui/icons/PlayCircleFilledWhite";
import StopIcon from "@material-ui/icons/Stop";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { Edit } from "@material-ui/icons";
import Chip from "@material-ui/core/Chip";

// Import Pages
import DataTable from "../../../../components/DataTable/DataTable";
import DataTableLoader from "../../../../components/ContentLoader/DataTableLoader";
import { personalizationState } from "../../../../recoil-store/recoil-state";

// Import Helper
import { convertToDateFormat } from '../../../../helpers/helper';

const styledButton = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
}
const styledSpan = {
    fontWeigt: "bold",
    color: "var(--manatee)",
    fontSize: "11px"
}
const styledEditButton = {
    width: "14px",
    height: "14px",
    color: "var(--manatee)",
    marginRight: "5px"
}

const InstalledAutoms = ({ searchData, setCustomColumn, handleRowsDelete, handleStatusChange, loadingDelete, customColumn, loading, botLimit, activeAutomLen }) => {
    const { t } = useTranslation();

    const personalization = useRecoilValue(personalizationState);

    // stopped ipaas bots
    async function handleStopOperation(id) {
        // const response = await IpaasService.stopIpaas(id)
        // if (response) {
        //     setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.STORE." + response.message), severity: response.status ? 'success' : 'error' }))
        // } else {
        //     setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        // }
        // setRefresh(!refresh);
    }

    // started ipaas bots
    async function handleStartOperation(id, index) {
        // data[index].is_running = 1;
        // setData(JSON.parse(JSON.stringify(data)));
        // const response = await IpaasService.startIpaas(id)
        // if (response) {
        //     setAlert(alert => ({ ...alert, show: true, message: t("MESSAGES.STORE." + response.message), severity: response.status ? 'success' : 'error' }))
        // } else {
        //     setAlert(alert => ({ ...alert, show: true, message: t('GENERAL.NETWORK-ERROR'), severity: 'error' }))
        // }
        // setRefresh(!refresh);
    }

    const handleOpenWebHook = (id) => {
        // setOpenWebHook(true);
        // setAutomId(id);
    }
    const handleOpenVariable = (id) => {
        // setOpenVariable(true);
        // setAutomId(id);
    }

    useEffect(() => {
        const column = [
            {
                id: 0,
                name: "id",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            }, {
                id: 1,
                name: 'status',
                label: t('CONTENT.USER.STATUS'),
                options: {
                    filter: false, sort: false,
                    customBodyRenderLite: (dataIndex, rowIndex) => {
                        if (searchData[dataIndex]) {
                            return (
                                <Switch
                                    checked={!!searchData[dataIndex]?.status}
                                    onChange={(e) => {
                                        handleStatusChange(e, searchData[dataIndex]?.id).then(r => r)
                                    }}
                                    color="primary"
                                />
                            );
                        }
                    }
                }
            },
            {
                id: 2,
                name: "name",
                label: t("CONTENT.AUTOMS-LIST.AUTOM-NAME"),
                options: { filter: true, sort: true },
            },
            {
                id: 3,
                name: "description",
                label: t("CONTENT.AUTOMS-LIST.DESCRIPTION"),
                options: {
                    filter: true, sort: true, display: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            if (searchData[dataIndex]?.description === '') {
                                searchData[dataIndex].description = "-";
                            }
                            return searchData[dataIndex]?.description;
                        }
                    },
                }
            },
            {
                id: 4,
                name: "version",
                label: t("CONTENT.LIBRARIES.VERSION"),
                options: {
                    filter: true,
                    sort: true,
                    display: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return (
                                <div>
                                    <Chip style={{ marginRight: "5px" }} color="primary" size="small"
                                        label={`v${searchData[dataIndex].active_version}`} />
                                </div>
                            )
                        }
                    },
                },
            },
            {
                id: 5,
                name: "integration_type",
                label: t("CONTENT.AUTOMS-LIST.INTEGRATION-TYPE"),
                options: { filter: true, sort: true },
            },
            {
                id: 8,
                name: "created_by_fullname",
                label: t("CONTENT.AUTOMS-LIST.CREATED-BY"),
                options: { filter: true, sort: true },
            },
            {
                id: 9,
                name: "created_at",
                label: t("CONTENT.AUTOMS-LIST.CREATED-AT"),
                options: {
                    filter: true, sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData[dataIndex]) {
                            return <div key={0}>{convertToDateFormat(searchData[dataIndex].created_at, personalization.date_format)}</div>
                        }
                    },
                }
            },
            {
                id: 10,
                name: "updated_at",
                label: t("CONTENT.AUTOMS-LIST.UPDATED-AT"),
                options: {
                    filter: true, sort: true, display: false,
                    customBodyRenderLite: (dataIndex) => {

                        if (searchData[dataIndex]) {
                            return (
                                <div key={0}>{convertToDateFormat(searchData[dataIndex].updated_at, personalization.date_format)}</div>
                            )
                        }
                    },
                }
            },
            {
                id: 11,
                name: "actions",
                label: " ",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        // Show edit icon if the status of the current autom is true and the user has less autom than specified in the license
                        if (searchData[dataIndex] && searchData[dataIndex].status === 1 && botLimit >= activeAutomLen) {
                            return (
                                <Link
                                    data-test="autom-link"
                                    to={`/automs/${searchData[dataIndex]?.id}/autom/edit`}
                                >
                                    <Edit />
                                </Link>
                            );
                        }
                    },
                },
            },
        ]
        setCustomColumn(column)
    }, [searchData, t])

    return (
        loading ? <DataTableLoader /> :
            <Grid
                item
                sm={12}
                data-test="listautom-page"
            >
                <DataTable
                    data-test="automlist-datatable"
                    customColumns={customColumn}
                    onRowsDelete={handleRowsDelete}
                    selectableRows="multiple"
                    data={searchData ? searchData : []}
                    title={t("CONTENT.AUTOMS-LIST.AUTOM-LIST")}
                    loading={loading}
                    loadingDelete={loadingDelete}
                />
            </Grid>
    );
};

export default InstalledAutoms;
